import { render, staticRenderFns } from "./AssignDevices.vue?vue&type=template&id=de87b5ba&scoped=true&"
import script from "./AssignDevices.vue?vue&type=script&lang=js&"
export * from "./AssignDevices.vue?vue&type=script&lang=js&"
import style0 from "./AssignDevices.vue?vue&type=style&index=0&id=de87b5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de87b5ba",
  null
  
)

export default component.exports